function positionDeliveryWidget() {
    // Get the delivery widget element
    const deliveryWidget = document.querySelector('.delivery-widget');

    // Exit early if widget doesn't exist
    if (!deliveryWidget) {
        return;
    }

    // Get the first section element in the body
    const firstSection = document.body.querySelector('section');

    // Exit early if no section found
    if (!firstSection) {
        return;
    }

    // Get the height of the first section
    const sectionHeight = firstSection.offsetHeight;

    // Get the offset top of the first section relative to the document
    const sectionTop = firstSection.offsetTop;

   // Get the height of the delivery widget
    const widgetHeight = deliveryWidget.offsetWidth;

   // Calculate the halfway point and subtract half the widget height to center it
    const halfwayPoint = sectionTop + (sectionHeight / 2) - (widgetHeight)

    // Set the top position of the delivery widget (works for both mobile and desktop now)
    deliveryWidget.style.top = `${halfwayPoint}px`;

    // Add fade-in class for GSAP animation
    deliveryWidget.classList.add('widget-fade-in');

    // Trigger GSAP animation after positioning is complete
    animateDeliveryWidget();

    // Add click event listener for booking menu
    addDeliveryWidgetClickHandler();
}

function addDeliveryWidgetClickHandler() {
    const deliveryWidget = document.querySelector('.delivery-widget');
    const deliveryWidgetMobile = document.querySelector('.delivery-widget-mobile');

    if (!deliveryWidget) {
        return;
    }

    if (!deliveryWidgetMobile) {
        return;
    }

    // Remove existing click listeners to prevent duplicates
    deliveryWidget.removeEventListener('click', handleDeliveryWidgetClick);
    deliveryWidgetMobile.removeEventListener('click', handleDeliveryWidgetClick);

    // Add click event listener
    deliveryWidget.addEventListener('click', handleDeliveryWidgetClick);
    deliveryWidgetMobile.addEventListener('click', handleDeliveryWidgetClick);
}

function handleDeliveryWidgetClick(event) {
    const widget   = event.currentTarget;
    const provider = widget.dataset.bookingProvider ?? 'healthengine';
    const url      = widget.dataset.bookingUrl;

    if (provider === 'external_link' && url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    } else {
        openBookingMenu();
    }
}

function animateDeliveryWidget() {
    // Check if GSAP is available
    if (typeof gsap === 'undefined') {
        return;
    }

    const deliveryWidget = document.querySelector('.delivery-widget.widget-fade-in');

    if (!deliveryWidget) {
        return;
    }

    // Set initial state (hidden)
    gsap.set(deliveryWidget, {
        autoAlpha: 0,
        x: 200,
        y: 0
    });

    // Create animation timeline
    var tl = gsap.timeline({
        delay: 0.2 // Small delay after positioning calculation
    });

    // Both mobile and desktop - fade in from right
    tl.to(deliveryWidget, {
        duration: 1.5,
        autoAlpha: 1,
        x: 0,
        ease: "circ.out",
    });
}

// Booking Menu Functions
function createBookingIframe() {
    // Iframe wrapper is in footer, completely decoupled from booking menu
    const iframeWrapper = document.querySelector('.booking-menu__iframe-wrapper');
    
    if (!iframeWrapper) {
        return;
    }

    // Check if iframe already exists - reuse it if it does
    const existingIframe = iframeWrapper.querySelector('iframe');
    if (existingIframe) {
        return; // Iframe already exists, reuse it
    }

    // Create the iframe element
    const iframe = document.createElement('iframe');
    const iframeSrc = 'https://healthengine.com.au/webplugin/?id=44947&source=webplugin&trigger=button&_gl=1*pdtbp6*_gcl_au*NDk1NDMwNTUuMTc1ODI1OTc5Mg..*_ga*NTI5MzEyMjc5LjE3NTgyNTk3OTQ.*_ga_8699PZQE76*czE3NTgyNTk3OTMkbzEkZzAkdDE3NTgyNTk3OTMkajYwJGwwJGgw';
    iframe.name = 'open-appointments-widget-44947';
    iframe.src = iframeSrc;
    
    // Append iframe to wrapper
    iframeWrapper.appendChild(iframe);
}


function openBookingMenu() {
    const bookingMenu = document.querySelector('.booking-menu');
    const bookingMenuContent = document.querySelector('.booking-menu__content');
    const bookingMenuLogo = document.querySelector('.booking-menu__logo');
    const closeButton = document.querySelector('.booking-menu__button--close');
    const closeText = document.querySelector('.booking-menu__close-text');

    if (!bookingMenu) {
        return;
    }

    // Check if GSAP is available
    if (typeof gsap === 'undefined') {
        return;
    }

    // Check if mobile
    const isMobile = () => window.innerWidth <= 1024;

    // Add body class to prevent scrolling and show iframe wrapper
    document.body.classList.add('booking-menu-open');

    // Create the iframe when menu opens (iframe wrapper is in footer)
    createBookingIframe();

    // Animation settings
    const SLIDE_DURATION = 0.6;
    const SLIDE_EASE = "power2.out";

    // Set initial states for header elements
    if (bookingMenuLogo) {
        gsap.set(bookingMenuLogo, {
            x: -100,
            opacity: 0,
        });
    }

    if (closeButton) {
        gsap.set(closeButton, {
            x: 100,
            opacity: 0,
        });
    }

    if (closeText) {
        gsap.set(closeText, {
            x: 20,
            opacity: 0,
        });
    }

    // booking-menu__content is now just an empty modal overlay - no opacity management needed

    // Create animation timeline
    const openTimeline = gsap.timeline({
        onComplete: function() {
            // Show content after menu animation is complete (using CSS, not GSAP)
            animateBookingMenuContent();
        }
    });

    // Both mobile and desktop - slide from top
    gsap.set(bookingMenu, {
        top: "-130vh",
        left: 0
    });

    openTimeline.to(bookingMenu, {
        top: 0,
        duration: SLIDE_DURATION,
        ease: "power2.inOut",
    });

    // Add close button event listener
    if (closeButton) {
        closeButton.addEventListener('click', closeBookingMenu);
    }

    // Add close text event listener
    if (closeText) {
        closeText.addEventListener('click', closeBookingMenu);
    }

    // Add escape key listener
    document.addEventListener('keydown', handleBookingMenuEscapeKey);
}

function animateBookingMenuContent() {
    const bookingMenuContent = document.querySelector('.booking-menu__content');
    const bookingMenuLogo = document.querySelector('.booking-menu__logo');
    const closeButton = document.querySelector('.booking-menu__button--close');
    const closeText = document.querySelector('.booking-menu__close-text');

    // Check if mobile
    const isMobile = () => window.innerWidth <= 1024;

    // Animate logo (desktop and mobile)
    if (bookingMenuLogo) {
        gsap.to(bookingMenuLogo, {
            x: 0,
            opacity: 1,
            duration: 0.4,
            ease: "power2.out",
            delay: 0.2,
        });
    }

    // Animate close button (desktop and mobile)
    if (closeButton) {
        gsap.to(closeButton, {
            x: 0,
            opacity: 1,
            duration: 0.4,
            ease: "power2.out",
            delay: 0.4,
        });
    }

    // Animate close text (desktop only)
    if (closeText && !isMobile()) {
        gsap.to(closeText, {
            x: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power3.out",
            delay: 0.6,
        });
    }

    // booking-menu__content is just an empty overlay - iframe wrapper handles its own opacity
}

function closeBookingMenu() {
    const bookingMenu = document.querySelector('.booking-menu');
    const bookingMenuContent = document.querySelector('.booking-menu__content');
    const bookingMenuLogo = document.querySelector('.booking-menu__logo');
    const closeButton = document.querySelector('.booking-menu__button--close');
    const closeText = document.querySelector('.booking-menu__close-text');

    if (!bookingMenu) {
        return;
    }

    // Check if GSAP is available
    if (typeof gsap === 'undefined') {
        return;
    }

    // Check if mobile
    const isMobile = () => window.innerWidth <= 1024;

    // Remove body class to allow scrolling and hide iframe wrapper
    document.body.classList.remove('booking-menu-open');

    // Animation settings
    const SLIDE_DURATION = 0.6;

    // Create closing timeline for better control
    const closeTimeline = gsap.timeline();

    // booking-menu__content is just an empty overlay - iframe wrapper handles its own opacity

    // Hide close text (desktop only)
    if (closeText && !isMobile()) {
        closeTimeline.to(closeText, {
            opacity: 0,
            x: 20,
            duration: 0.3,
            ease: "power2.in",
        }, "-=0.2");
    }

    // Hide logo and close button
    closeTimeline.to(
        [bookingMenuLogo, closeButton].filter(Boolean),
        {
            x: function (i) {
                return i === 0 ? -100 : 100;
            },
            opacity: 0,
            duration: 0.3,
            ease: "power2.in",
        },
        "-=0.2"
    );

    // Finally, slide out the menu
    closeTimeline.call(() => {
        // Both mobile and desktop - slide out to top
        gsap.to(bookingMenu, {
            top: "-130dvh",
            duration: SLIDE_DURATION,
            ease: "power2.in",
            onComplete: () => {
                // Reset to initial state
                gsap.set(bookingMenu, {
                    top: "-130dvh",
                    left: 0
                });
                resetBookingMenuElements();
            }
        });
    });

    // Remove escape key listener
    document.removeEventListener('keydown', handleBookingMenuEscapeKey);
}

function resetBookingMenuElements() {
    const bookingMenuContent = document.querySelector('.booking-menu__content');
    const bookingMenuLogo = document.querySelector('.booking-menu__logo');
    const closeButton = document.querySelector('.booking-menu__button--close');
    const closeText = document.querySelector('.booking-menu__close-text');

    // Reset all elements to initial hidden state
    if (bookingMenuLogo) {
        gsap.set(bookingMenuLogo, { x: -100, opacity: 0 });
    }

    if (closeButton) {
        gsap.set(closeButton, { x: 100, opacity: 0 });
    }

    if (closeText) {
        gsap.set(closeText, { x: 20, opacity: 0 });
    }

    // booking-menu__content is just an empty overlay - no opacity management needed
}

function handleBookingMenuEscapeKey(e) {
    if (e.key === 'Escape') {
        closeBookingMenu();
    }
}

// Integration with existing search menu close button
function setupSearchMenuCloseIntegration() {
    const searchMenuCloseButton = document.querySelector('.search-menu__button--close');

    if (searchMenuCloseButton) {
        searchMenuCloseButton.addEventListener('click', function() {
            // Close booking menu if it's open
            const bookingMenu = document.querySelector('.booking-menu');
            if (bookingMenu && document.body.classList.contains('booking-menu-open')) {
                closeBookingMenu();
            }
        });
    }
}

// Function to handle resize events with debouncing
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Function to handle resize - reposition and re-animate
function handleResize() {
    const deliveryWidget = document.querySelector('.delivery-widget');
    if (deliveryWidget) {
        // Reset animation classes
        deliveryWidget.classList.remove('widget-fade-in');

        // Kill any existing GSAP animations on this element
        if (typeof gsap !== 'undefined') {
            gsap.killTweensOf(deliveryWidget);
        }

        // Reposition and animate
        positionDeliveryWidget();
    }
}

// Debounced resize handler
const debouncedHandleResize = debounce(handleResize, 150);


// Initialize positioning when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        positionDeliveryWidget();
        setupSearchMenuCloseIntegration();
    });
} else {
    positionDeliveryWidget();
    setupSearchMenuCloseIntegration();
}
